// extracted by mini-css-extract-plugin
module.exports = {"container":"_28VptgEh","logo":"KnyGipiZ"};